import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { checkAuth } from '../../store/slices/auth-slice';

const AuthCheck = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Check if user is authenticated on component mount
    dispatch(checkAuth());
  }, [dispatch]);

  // This component doesn't render anything
  return null;
};

export default AuthCheck;
